import {Injectable} from '@angular/core';
import {Backend} from '@generated-backend-types';
import {BaseEndpointService} from '../base-endpoint-service';
import {ListItem} from '../../../entities/list-item.entity';
import TimeTrackingEmployeeData = Backend.App.Data.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployeeData;
import TimeTrackingEmployee = Backend.App.Resources.Dashboard.TimeTracking.TimeTrackingEmployee.TimeTrackingEmployee;

@Injectable({providedIn: 'root'})
export class TimeTrackingEmployeeService extends BaseEndpointService<TimeTrackingEmployee, TimeTrackingEmployeeData> {
  protected override endpoint = '/time-tracking/employees';

  public override modelToMultiSelectItem(m: TimeTrackingEmployee): ListItem & { model: TimeTrackingEmployee; } {
    return {
      id: m.id,
      text: m.user ? m.user.name : m.id,
      isDisabled: false,
      model: m,
    }
  }
}
